import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import leftarrow from "../../../assets/images/left-arrow.svg";
import styles from './passwordAuthorization.module.css';
import { Footer } from '../../common/footer/footer';
import eyeiconunfold from "../../../assets/images/eyeiconunfold.svg";
import eyeIcon from "../../../assets/images/eyeicon.svg";
import { Timer } from '../timer/timer';
import { useHistory } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

const PassJsx = (props) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState({});
  const toggleShowPassword = (fieldName) => {
    setShowPassword(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName]
    }));
  };
  const history = useHistory();
  const {
    OTP,
    timerStart,
    OnInputChange,
    onTimerComplete,
    onResendOTPClick,
    formSubmitHandler
  } = props;

  return (
    <>
      <section className="mainloginscreen">
        <div className="container">

          <div className={`${styles.mainloginscreeninner}`}>
            <div className={`${styles.leftsightbackdetails} d-flex`}>
              <div className="d-flex plaindetailsleft align-items-center justify-content-center">
                <div className="back_btn" onClick={() => history.goBack()}><img src={leftarrow} alt={'icon'} /></div>
               
                  {localStorage.getItem('flowName') === 'login' ?
                    <h1>{t("PASSWORDAUTHORIZATION.TITLE2")}</h1> :
                    <h1>{t("PASSWORDAUTHORIZATION.TITLE")}</h1>
                  }

               

              </div>
            </div>
          </div>
          <div className={`${styles.formsection} customer`}>
            <div className={`${styles.institutelogintext}`}>
              {localStorage.getItem('flowName') === 'login' ?
                <h2 className="h2_style">{t("PASSWORDAUTHORIZATION.ENTEROTP")}<br/>
              {t("PASSWORDAUTHORIZATION.check_OTP")} <br/>{t("PASSWORDAUTHORIZATION.SENDOTP")} </h2>
                :
                <h2 className="h2_style">{t("PASSWORDAUTHORIZATION.SECUREACCOUNT")}
                  <br />{t("PASSWORDAUTHORIZATION.SETPASSWORD")} </h2>
              }
              {localStorage.getItem('flowName') === 'login' ?
                <h4 className="mt-3">{t("PASSWORDAUTHORIZATION.check_onetime")} {t("PASSWORDAUTHORIZATION.P_bellow")} 
                 </h4>
                :
                <h4 className="mt-3">{t("PASSWORDAUTHORIZATION.CHECKMAIL")}<br />
                  {t("PASSWORDAUTHORIZATION.SENDOTP")} <br />
                  {t("PASSWORDAUTHORIZATION.PLEASEENTER")}</h4>
              }


<div className={`${styles.formsectioninner}`}>
              <div className={`input-container form-group ${styles.formfield}`}>
                <div className={`${styles.small}`}>{t("PASSWORDAUTHORIZATION.ENTEROTP")}</div>
                <input 
                maxLength="4" 
                type={showPassword['password'] ? 'text' : 'password'}
                className="input form-control" 
                placeholder={t("PASSWORDAUTHORIZATION.ENTEROTP")} 
                value={OTP} 
                onChange={OnInputChange} />
               
                <span
  className={`${styles.form_image}`}
  onClick={() => toggleShowPassword('password')}
  style={{ cursor: 'pointer' }}
>
  {showPassword['password'] ? (
    <img alt="Hide password" src={eyeiconunfold} />
  ) : (
    <img alt="Show password" src={eyeIcon} />
  )}
</span>

              </div>
              <div className={`${styles.checkspam}`}>{t("PASSWORDAUTHORIZATION.DONTFORGET")}</div>
              <div className="d-flex align-items-center justify-content-center"> <button type="submit" className={
                !OTP
                  ? "mt-3 mainbutton mb-3"
                  : "mt-3 mainbutton mb-3"
              } onClick={formSubmitHandler} disabled={!OTP}>{t("PASSWORDAUTHORIZATION.CONTINUE")}</button></div>
              {
                timerStart ? <div className="otptime"><Timer show={timerStart} onCompletion={() => onTimerComplete()} /></div>
                  :
                  <div className="otptime" onClick={onResendOTPClick}> {t("PASSWORDAUTHORIZATION.RESENDOTP")}</div>
              }
            </div>
</div>
          </div>
          <Footer />
        </div>
      </section>
      <ToastContainer />

    </>

  );
};

export default PassJsx;
